import React, { forwardRef } from "react";
import styles from "./button.module.css";

const ButtonBack = forwardRef((props, ref) => {
  return (
    <div className={styles.body}>
      <button
        ref={ref}
        className={styles.button2}
        onClick={props.onClick}
        type="button"
      >
        <div>{props.children}</div>
      </button>
    </div>
  );
});

export default ButtonBack;
